<template>
  <ul :class="{ tree: level == 0 }">
    <li class="tree-header" v-if="level == 0">
      <span
        class="tree-header-item"
        :class="{ 'flex-auto': !column.width }"
        v-for="column in columns"
        :key="column.key"
        :style="{ width: column.width ? column.width + 'px' : 'auto' }"
        >{{ column.title }}</span
      >
    </li>
    <li class="tree-item" v-for="(item, index) in items" :key="item.id">
      <div class="tree-item-content">
        <span
          class="tree-item-arrow"
          :class="{
            'tree-item-arrow-open': expand['item' + index.toString()] == 1
          }"
          @click="toggleExand(item, index)"
        >
          <i
            class="ivu-icon ivu-icon-ios-arrow-forward"
            v-if="item.children && item.children.length > 0"
          ></i>
        </span>
        <template v-for="(column, colIndex) in columns">
          <span
            :class="{
              'flex-auto': !column.width,
              center: column.align == 'center'
            }"
            :key="
              'item-' +
                level.toString() +
                '-' +
                index.toString() +
                '-' +
                colIndex
            "
            :style="{ width: column.width ? column.width + 'px' : 'auto' }"
          >
            <slot
              v-if="column.slot"
              :name="column.slot"
              :item="item"
              :level="level"
            ></slot>
            <template v-else>{{ item[column.key] }}</template>
          </span>
        </template>
      </div>
      <TreeViewExpand
        v-if="expand['item' + index.toString()] == 1"
        :items="item.children || []"
        :level="level + 1"
        :columns="columns"
        :scopedSlots="$scopedSlots"
      ></TreeViewExpand>
    </li>
  </ul>
</template>
<script>
import Vue from "vue";
Vue.component("TreeView", () => import("./TreeView.vue"));

export default {
  name: "TreeView",
  props: {
    level: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      expand: {}
    };
  },
  components: {
    TreeViewExpand: {
      props: {
        level: {
          type: Number,
          default: 0
        },
        columns: {
          type: Array,
          default: () => {
            return [];
          }
        },
        items: {
          type: Array,
          default: () => {
            return [];
          }
        },
        scopedSlots: {}
      },
      render(h) {
        return h("TreeView", {
          props: {
            level: this.level,
            columns: this.columns,
            items: this.items
          },
          scopedSlots: this.scopedSlots
        });
      }
    }
  },
  created() {
    this.buildExpand();
  },
  methods: {
    buildExpand() {
      let expand = {};
      for (let i = 0; i < this.items.length; i++) {
        expand["item" + i] = this.items[i]._expanded || 0;
      }
      this.expand = expand;
    },
    toggleExand(item, index) {
      let key = "item" + index;
      this.expand[key] = this.expand[key] ? 0 : 1;
    }
  },
  watch: {
    items() {
      this.buildExpand();
    }
  }
};
</script>
<style scoped lang="scss">
.tree {
  border: 1px solid #dcdee2;
  border-bottom: none;

  li ul .tree-item-content {
    padding-left: 35px;
  }
}

.tree-header {
  height: 40px;
  font-weight: bold;
  text-align: center;
  display: flex;
  align-items: center;
  background-color: #f8f8f9;
  padding: 0 15px;
  border-bottom: 1px solid #e8eaec;
}

.tree-header-item {
  display: block;
}

.flex-auto {
  flex-grow: 1;
}

.tree-item-content {
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8eaec;
  padding: 0 15px;
  background-color: transparent;
  transition: all 0.25s;

  &:hover {
    background-color: #ebf7ff;
  }
}

.tree-item-arrow {
  width: 12px;
  text-align: center;
  cursor: pointer;
  margin-right: 15px;
}

.tree-item-arrow-open {
  i {
    transform: rotate(90deg);
  }
}
</style>
